export const SIZES_MAP = {
  xxs: "size-1",
  xs: "size-2",
  sm: "size-4",
  md: "size-6",
  lg: "size-8",
  xl: "size-12",
};
